<template>
    <div class="store-health-check">
      <div class="animated fadeIn">
        <b-row>
          <b-col cols="12">
            <b-card class="mt-2">
              <div slot="header">
                <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('report.contactless_curbside_transactions') }}</strong>
              </div>
              <b-row>
                <b-col cols="12">
                  <b-btn id="btn-csv-files" v-b-toggle.collapse1 variant="success">CSV Files</b-btn>
                  <b-collapse id="collapse1">
                    <b-card v-if="data.length > 0" class="mt-3">
                      <div v-for="(item, i) in data" :key="i" :class="`w-100 d-flex align-items-center item-csv mt-${i === 0 ? '0' : '3'}`" style="cursor: pointer;" @dblclick="() => downloadFileCSV(item)">
                        <i class="fa fa-fw fa-file-excel-o mr-1"></i>
                        <span>{{ item.name }}</span>
                      </div>
                    </b-card>
                    <b-card v-else-if="isLoad && data.length === 0" class="mt-3">
                      <div>{{ $t("message.no_data") }}</div>
                    </b-card>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </div>
  </template>
  <script>
    export default {
      name: 'StoreHealthCheck',
      data () {
        return {
          isLoad: false,
          timeout: null,
          data: []
        }
      },
      mounted () {
        this.getListCSV()
      },
      destroyed () {
        clearTimeout(this.timeout)
        this.timeout = null
      },
      methods: {
        getListCSV () {
          const vm = this
          vm.data = []
          vm.isLoad = true
          this.axios.getListCSV(null, async function (response) {
            const data = response.data && response.data.data || []
            for (let i = 0; i < data.length; i++) {
              vm.data.push({
                id: i,
                name: data[i],
                icon: "fa fa-fw fa-file-excel-o"
              })
            }
            setTimeout(() => {
              document.getElementById('btn-csv-files').click()
            }, 300)
          })
        },
        downloadFileCSV (item) {
          const vm = this
          if (!item || item.id === -1 || !item.name || this.timeout) {
            return;
          }
          try {
            this.$bus.$emit('loading', 'block')
            this.timeout = setTimeout(() => {
              clearTimeout(this.timeout)
              vm.timeout = null
              vm.axios.downloadCSV(item.name, async function (response) {
                const encodedUri = encodeURI("data:text/csv;charset=utf-8," + response.data);
                const link = document.createElement("a");
                link.setAttribute('download', item.name);
                link.href = encodedUri;
                document.body.appendChild(link);
                link.click();
                vm.$bus.$emit('loading', 'none')
              })
            }, 1000);
          } catch (error) {
            this.$bus.$emit('loading', 'none')
            console.error('Error function downloadFileCSV: ' + error)
          }
        }
      }
    }
  </script>
  
  <style scoped>
   .item-csv:hover {
    font-weight: bold;
    text-decoration: underline;
    transition: 100ms all;
   }
  </style>



// WEBPACK FOOTER //
// src/views/admin/report/ContactlessCurbsideTransactions.vue